import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { AssetAmount } from "@sundaeswap/asset";
import { useHydrozoaHeadInfo } from "@/hooks/useHydrozoaScriptAddress";
import { formatAda } from "@/lib/utils";

export function useHeadAdaBalance() {
  const headInfo = useHydrozoaHeadInfo();
  const headAddress = headInfo?.headAddress;

  const { data: lovelace, isLoading } = useQuery({
    queryKey: ["head-ada-balance", headAddress],
    enabled: !!headAddress,
    refetchInterval: 30_000,
    queryFn: async () => {
      const network = window.__APP_CONFIG.env === "mainnet" ? "mainnet" : "preview";
      const res = await fetch(
        `https://cardano-${network}.blockfrost.io/api/v0/addresses/${headAddress}`,
        {
          headers: {
            project_id: window.__APP_CONFIG.blockfrostProjectId,
          },
        },
      );

      if (!res.ok) return null;

      const data = await res.json();
      const ada = data.amount?.find(
        (amount: { unit: string; quantity: string }) => amount.unit === "lovelace",
      );

      return ada?.quantity ?? null;
    },
  });

  const formatted = useMemo(() => {
    if (!lovelace) return null;

    const amount = new AssetAmount(BigInt(lovelace), {
      decimals: 6,
      assetId: "ada.lovelace",
    });

    return formatAda(amount);
  }, [lovelace]);

  return {
    lovelace,
    formatted,
    isLoading,
  };
}
